import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { CaseDocument } from '../../data/types';

export type CaseDocumentState = {
    documents: CaseDocument[],
}

export const useCaseDocumentState = () => {
    const caseDocState = useSelector((state: RootState | any) => state.caseDocuments as CaseDocumentState);
    return caseDocState;
}

// Define the initial state using that type
const initialState: CaseDocumentState = {
    documents: [],
}

export const caseDocSlice = createSlice({
    name: 'caseDocuments',
    initialState: initialState,
    reducers: {
        setCaseDocumentsAction: (state, action: PayloadAction<CaseDocument[]>) => {
            state.documents = action.payload;
        },
        addOrReplaceCaseDocumentAction: (state, action: PayloadAction<CaseDocument>) => {
            const existingIndex = state.documents.findIndex((caseDoc: CaseDocument) => caseDoc?.docId === action.payload.docId);
            if (existingIndex >= 0) {
                state.documents[existingIndex] = action.payload;
            } else {
                state.documents.push(action.payload);
            }
        },
        removeCaseDocumentAction: (state, action: PayloadAction<string>) => {
            state.documents = state.documents.filter((x) => x.docId !== action.payload);
        },
    }
})

export const { addOrReplaceCaseDocumentAction, setCaseDocumentsAction, removeCaseDocumentAction } = caseDocSlice.actions;

export default caseDocSlice.reducer;